






import Vue from "vue";

export default Vue.extend({
  name: "NamedButton",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    action: Number,
    name: String,
    value: [Number, String],
  },
  methods: {
    submitForm(value: number | string): void {
      this.$store.dispatch("ajax", {
        data: {
          [this.name]: value,
        },
        action: this.action,
      });
    },
  },
});
